import { Container } from "@mui/material";
import { FriendModal } from "./FriendsContents";
import { FriendAcceptModal } from "./FriendAccepted";
import { db } from "../Firebase/firebase";
import Loader from "./Loader";
import { collection, onSnapshot, query, getDocs, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { FriendRequestModal } from "./FriendsRequestContent";
import { UserAuth } from "../Firebase/authcontext";
import styled from "styled-components";

const FriendCard = () => {
  const { user } = UserAuth();
  const [friend_arr, set_friend_arr] = useState([]);
  const [loading, setLoading] = useState(true);
  const [friend_request_list, set_friend_request_list] = useState([]);
  const [friendRequestsData, setFriendRequestsData] = useState([]);
  const [my_friend_list, set_my_friend_list] = useState([]);

  // Fetch current user's data
  useEffect(() => {
    if (!user?.uid) return;

    const unsubscribe = onSnapshot(
      query(collection(db, "User"), where("uid", "==", user.uid)),
      (snapshot) => {
        if (!snapshot.empty) {
          const data = snapshot.docs[0].data();
          set_friend_request_list(data.incoming_request || []);
          set_my_friend_list(data.friendId_list || []);
        }
      }
    );

    return () => unsubscribe();
  }, [user?.uid]);

  // Fetch all users except current user
  useEffect(() => {
    if (!user?.uid) return;

    const unsubscribe = onSnapshot(query(collection(db, "User")), (snapshot) => {
      const usersData = snapshot.docs
        .map((doc) => doc.data())
        .filter((data) => data.uid !== user.uid);
      set_friend_arr(usersData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user?.uid]);

  // Fetch incoming friend request data
  useEffect(() => {
    const fetchFriendRequests = async () => {
      if (!friend_request_list || friend_request_list.length === 0) return;

      try {
        const q = query(collection(db, "User"), where("uid", "in", friend_request_list));
        const querySnapshot = await getDocs(q);
        const requestsData = querySnapshot.docs.map((doc) => doc.data());
        setFriendRequestsData(requestsData);
      } catch (error) {
        console.error("Error fetching friend requests:", error);
      }
    };

    fetchFriendRequests();
  }, [friend_request_list]);

  // Fetch friend data for my_friend_list
  const [friendData, setFriendData] = useState([]);
  useEffect(() => {
    const fetchFriends = async () => {
      if (!my_friend_list || my_friend_list.length === 0) {
        setFriendData([]);
        return;
      }

      try {
        const q = query(collection(db, "User"), where("uid", "in", my_friend_list));
        const querySnapshot = await getDocs(q);
        const friendsData = querySnapshot.docs.map((doc) => doc.data());
        setFriendData(friendsData);
      } catch (error) {
        console.error("Error fetching friend data:", error);
      }
    };

    fetchFriends();
  }, [my_friend_list]);

  return loading ? (
    <Loader />
  ) : (
    <Container style={{ overflowY: "auto", maxHeight: "80vh" }}>
      <h3>Incoming Requests</h3>
      {friendRequestsData.length === 0 ? (
        <MessageBox>No incoming requests</MessageBox>
      ) : (
        friendRequestsData.map((user) => (
          <div key={user.uid}>
            <FriendRequestModal
              isrequest={true}
              uid={user.uid}
              name={user.displayName}
              img={user.photoURL}
              position={user.position}
            />
          </div>
        ))
      )}

      <h3>Friend Suggestions</h3>
      {friend_arr.filter((i) => !friend_request_list.includes(i.uid) && !my_friend_list.includes(i.uid)).length === 0 ? (
        <MessageBox>No friend suggestions</MessageBox>
      ) : (
        friend_arr.filter((i) => !friend_request_list.includes(i.uid) && !my_friend_list.includes(i.uid))
        .map((i) => {
          const isrequest = my_friend_list.includes(i.uid) || friend_request_list.includes(i.uid);
          return (
            <div key={i.uid}>
              <FriendModal
                isrequest={isrequest}
                uid={i.uid}
                name={i.displayName}
                img={i.photoURL}
                position={i.position}
              />
            </div>
          );
        })
      )}

      <h3>Friends</h3>
      {friendData.length === 0 ? (
        <MessageBox>No friends</MessageBox>
      ) : (
        friendData.map((friend) => (
          <div key={friend.uid}>
            <FriendAcceptModal
              isrequest={false}
              uid={friend.uid}
              email={friend.email}
              name={friend.displayName}
              img={friend.photoURL}
              position={friend.position}
            />
          </div>
        ))
      )}
    </Container>
  );
};

export default FriendCard;

const MessageBox = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 10px;
  margin: 10px 0;
  text-align: center;
`;
